import * as Sentry from '@sentry/nextjs';
import type { IUser } from '@/services/apis/user/types';

export const configSentry = (user: IUser) => {
  Sentry.configureScope((scope) => {
    scope.setExtra('ua', window.navigator.userAgent);
    scope.setTag('app', 'MofidApp');
    scope.setUser({
      id: user.nationalId,
      email: user.email ?? undefined,
      username: user.displayName,
      hashedPk: user.hashedPk,
    });
    // scope.clear();
  });
};
